// extracted by mini-css-extract-plugin
module.exports = {"root":"LayoutSettings_root__3GX1y","content":"LayoutSettings_content__7IIC-"};